import React from "react";
import Link from "next/link";
import { FooterProps } from "@/types/layout";
import Image from "next/image";

export const Footer: React.FC<FooterProps> = ({ navigationItems }) => {
  return (
    <div className="mb-[61px] mt-[70px] md:mb-0">
      <footer className="border-b border-footer-border bg-light-gray px-5 font-sans dark:border-footer-dark-border dark:bg-dark-gray max-lg:landscape:pl-[84.5px]">
        <ul className="flex flex-wrap py-1 text-dark dark:text-white lg:py-0">
          {navigationItems?.map((item, key) => (
            <li key={`footer-navigation-link-${key}`} className="[&>div]:last:hidden">
              <Link
                href={item.url}
                className="mr-3 flex items-center justify-between py-1 text-2xs hover:no-underline md:hover:underline lg:mr-6 lg:py-6"
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </footer>
      <footer className="hidden bg-light-gray p-5 font-sans dark:bg-dark-gray lg:flex max-lg:landscape:pl-[84.5px]">
        <div className="flex">
          <div className="border-r border-footer-border pr-6 dark:border-footer-dark-border">
            <Link href={"/"}>
              <Image src="/assets/images/footer-logo.svg" width={90} height={30} alt="Logo" className="dark:hidden" />
              <Image
                src="/assets/images/footer-logo-white.svg"
                width={90}
                height={30}
                alt="Logo"
                className="hidden dark:flex"
              />
            </Link>
          </div>
          <div className="flex border-r border-footer-border px-6 pt-1 dark:border-footer-dark-border">
            <Link href="https://twitter.com/reporter_cz" target="_blank">
              <Image
                src="/assets/images/icons/twitter-new.svg"
                alt="Bookmark Button"
                width={20}
                height={20}
                className="mr-6 h-[20px] w-[20px] object-cover dark:invert"
              />
            </Link>
            <Link href="https://www.facebook.com/reportermagazin/" target="_blank">
              <Image
                src="/assets/images/icons/facebook-new.svg"
                alt="Facebook Icon"
                width={20}
                height={20}
                className="h-[20px] w-[20px] object-cover dark:invert"
              />
            </Link>
          </div>
          <div className="flex border-r border-footer-border px-6 dark:border-footer-dark-border">
            <Link
              href="/hi-we-are-fatchilli/"
              className="flex font-sans text-footer font-light text-dark dark:text-white"
              target="_blank"
            >
              <span className="my-auto">Digital DNA by</span>
              <Image
                src="/assets/images/icons/fatchilli.svg"
                alt="FatChilli Icon"
                width={14.27}
                height={26.6}
                className="mx-1 my-auto h-[26.6px] w-[14.27px] object-cover"
              />
              <span className="my-auto">FatChilli</span>
            </Link>
          </div>
          <div className="flex pl-6">
            <span className="my-auto font-sans text-footer font-light text-dark dark:text-white">
              Copyright © Reportér Magazín, s. r. o.
            </span>
          </div>
        </div>
      </footer>

      <footer className="bg-light-gray p-5 font-sans dark:bg-dark-gray lg:hidden max-lg:landscape:pl-[84.5px]">
        <div className="border-b border-footer-border dark:border-footer-dark-border">
          <div className="flex justify-center">
            <div className="border-r border-footer-border pr-6 dark:border-footer-dark-border">
              <Link href={"/"}>
                <Image src="/assets/images/footer-logo.svg" width={90} height={30} alt="Logo" className="dark:hidden" />
                <Image
                  src="/assets/images/footer-logo-white.svg"
                  width={90}
                  height={30}
                  alt="Logo"
                  className="hidden dark:flex"
                />
              </Link>
            </div>
            <div className="border-r border-footer-border px-6 pt-1 dark:border-footer-dark-border">
              <Link href="https://twitter.com/reporter_cz" target="_blank">
                <Image
                  src="/assets/images/icons/twitter-new.svg"
                  alt="Bookmark Button"
                  width={20}
                  height={20}
                  className="h-[20px] w-[20px] object-cover dark:invert"
                />
              </Link>
            </div>
            <div className="pl-6 pt-1">
              <Link href="https://www.facebook.com/reportermagazin/" target="_blank">
                <Image
                  src="/assets/images/icons/facebook-new.svg"
                  alt="Facebook Icon"
                  width={20}
                  height={20}
                  className="h-[20px] w-[20px] object-cover dark:invert"
                />
              </Link>
            </div>
          </div>
          <div className="my-2 flex justify-center">
            <Link
              href="/hi-we-are-fatchilli/"
              className="dark:hover:decoration-light flex font-sans text-footer font-light text-dark underline decoration-transparent decoration-1 ease-in-out hover:decoration-dark dark:text-white"
              target="_blank"
            >
              <span className="my-auto">Digital DNA in by</span>
              <Image
                src="/assets/images/icons/fatchilli.svg"
                alt="FatChilli Icon"
                width={14.27}
                height={26.6}
                className="mx-1 my-auto h-[26.6px] w-[14.27px] object-cover"
              />
              <span className="my-auto">FatChilli</span>
            </Link>
          </div>
        </div>

        <div className="mt-3 w-full text-center">
          <span className="my-auto font-sans text-footer font-light text-dark dark:text-white">
            Copyright © Reportér Magazín, s. r. o.
          </span>
        </div>
      </footer>
    </div>
  );
};
